import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ThemeProvider from './providers/ThemeProvider';
import LocaleProvider from './providers/LocaleProvider';

ReactDOM.render(
  <React.StrictMode>
    <LocaleProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </LocaleProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
